import { useEffect, useMemo } from "react";
import PageBackButton from "../common/PageBackButton";

const Section = ({ id, eyebrow, title, children }) => {
  return (
    <section id={id} className="scroll-mt-24">
      <div className="space-y-2">
        {eyebrow ? (
          <p className="text-xs font-semibold tracking-wide text-violet-700/80">
            {eyebrow}
          </p>
        ) : null}
        <h2 className="text-base sm:text-lg font-semibold text-gray-900">
          {title}
        </h2>
      </div>
      <div className="mt-3 space-y-3 text-sm sm:text-[15px] leading-6 text-gray-700">
        {children}
      </div>
    </section>
  );
};

const TocLink = ({ href, children }) => (
  <a
    href={href}
    className="block rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-violet-50 hover:text-violet-800 transition"
  >
    {children}
  </a>
);

// components/TermsModal.jsx (route: /term-condition)
export const AboutUs = () => {
  useEffect(() => {
    const prev = document.title;
    document.title = "About Us • PhonebookPlus";
    return () => {
      document.title = prev;
    };
  }, []);

  const toc = useMemo(
    () => [
      { href: "#top", label: "About Us" },
      { href: "#privacy", label: " PhoneBookPlus is here to fix that!" },
      { href: "#privacy-1", label: "Features" },
      // { href: "#privacy-2", label: "2. Data Collected & Processing" },
      // { href: "#privacy-3", label: "3. Information Control Architecture" },
      // { href: "#privacy-4", label: "4. Data Localization" },
      // { href: "#privacy-5", label: "5. Third‑Party Integrations" },
      // { href: "#privacy-6", label: "6. DPDP Rights Execution" },
      // { href: "#terms", label: "Terms & Conditions" },
      // { href: "#terms-1", label: "1. User Accounts and Eligibility" },
      // { href: "#terms-2", label: "2. Data Ownership & IP" },
      // { href: "#terms-3", label: "3. Contact Sync Warranty" },
      // { href: "#terms-4", label: "4. Billing and Refunds" },
      // { href: "#terms-5", label: "5. Prohibited Use" },
      // { href: "#terms-6", label: "6. Liability Limitations" },
      // { href: "#terms-7", label: "7. Governing Law" },
    ],
    []
  );

  return (
    <div
      id="top"
      className="min-h-screen bg-gradient-to-b from-violet-50 via-white to-white"
    >
      <header className="sticky top-0 z-20 border-b border-violet-100/70 bg-white/80 backdrop-blur">
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
          <div className="py-4">
            <PageBackButton label="Back" fallback="/login" />
            <p className="text-xs font-semibold tracking-wide text-violet-700/80">
              PHONEBOOKPLUS TECHNOLOGY &amp; CONSULTING (OPC) PVT. LTD.
            </p>
            <h1 className="mt-1 text-lg sm:text-xl font-semibold text-gray-900">
        About Us
            </h1>
            {/* <p className="mt-1 text-xs text-gray-500">
              Legal compliance blueprint • DPDP Act, 2023 • India
            </p> */}
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl px-4 sm:px-6 py-8 sm:py-10 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-[280px_minmax(0,1fr)] gap-6 lg:gap-10">
          {/* TOC */}
          <aside className="lg:sticky lg:top-24">
            <div className="lg:max-h-[calc(100vh-7rem)] lg:overflow-auto lg:pr-1 lg:[scrollbar-width:none] lg:[-ms-overflow-style:none] lg:[&::-webkit-scrollbar]:hidden">
              <div className="rounded-2xl border border-violet-100 bg-white shadow-sm">
                <div className="px-4 py-3 border-b border-violet-100">
                  <p className="text-sm font-semibold text-gray-900">
                    On this page
                  </p>
                </div>
                <nav className="p-2">
                  {toc.map((item) => (
                    <TocLink key={item.href} href={item.href}>
                      {item.label}
                    </TocLink>
                  ))}
                </nav>
              </div>

              <div className="mt-4 rounded-2xl border border-gray-200 bg-white p-4 text-xs text-gray-600">
                <p className="font-semibold text-gray-900">Quick notes</p>
                <ul className="mt-2 space-y-2 list-disc pl-4">
                  <li>
                    This page is provided for transparency and compliance
                    reference.
                  </li>
                  <li>
                    For support or compliance requests, contact the Grievance
                    Officer via the in-app route.
                  </li>
                </ul>
              </div>
            </div>
          </aside>

          {/* CONTENT */}
          <div className="min-w-0">
            <div className="rounded-2xl border border-violet-100 bg-white shadow-sm">
              <div className="px-5 sm:px-8 py-6 sm:py-8">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                  <div className="space-y-1">
                    <h2 className="text-base sm:text-lg font-semibold text-gray-900">
                    About  PhoneBookPlus
                    </h2>
                   
                  </div>
                  {/* <div className="rounded-xl bg-violet-50 px-3 py-2 text-xs text-violet-900">
                    <p className="font-semibold">Last updated</p>
                    <p className="text-violet-800/80">May 2026</p>
                  </div> */}
                </div>

                <div className="mt-5 text-sm sm:text-[15px] leading-6 text-gray-700">
                  <p dir="ltr">
                  Think about how many places your contacts are scattered right now—some are in your phone’s basic address book, some are hidden in messaging platforms, others are locked in work emails, and a few are jotted down in notebooks. On top of that, your close friends, family members, local clients, and global business partners are all jumbled together in one giant, messy alphabetical list.

                  </p>
                </div>

                <div className="my-7 h-px bg-violet-100" />

                <div className="space-y-10">
                  <section id="privacy" className="scroll-mt-24">
                    <h2 className="text-lg sm:text-xl font-bold text-gray-900">
                     PhoneBookPlus is here to fix that!
                    </h2>
                    <p className="mt-2 text-sm sm:text-[15px] leading-6 text-gray-700">
                     It is an easy-to-use, vibrant platform that brings your entire network into one beautifully organized space.  PhoneBookPlus helps you separate your personal life from your professional work, giving you the power to talk, plan, and stay in touch with everyone seamlessly. Whether you are catching up with family or managing key business clients,  PhoneBookPlus takes the stress out of staying connected so you can focus on the conversations that matter.
                    </p>
                  </section>

                

                  <Section
                    id="privacy-2"
                    eyebrow="Features"
                    // title="2. Categorization of Data Collected & Processing Methods"
                  >
                   
                    <ul className="list-disc pl-5 space-y-2">
                      <li>
                        <span className="font-semibold text-gray-900">
                         📱 Well-Organized Contacts
                        </span>
                      </li>
                      <li>
                        <span className="font-semibold text-gray-900">
                         🔒 Complete Control Over Your Data — You Decide Who Sees What

                        </span>
                        </li>
                      <li>
                        <span className="font-semibold text-gray-900">
                         🎙️ Say More in Less Time — Intuitive, Distraction-Free Voice Chat

                        </span>
                      </li>
                      <li>
                        <span className="font-semibold text-gray-900">
                         ✈️ Offline Mode for When You Are Away

                        </span>
                       
                      </li>
                      <li>
                        <span className="font-semibold text-gray-900">
                          📅 Organize Yourself Better — Smart Planning Tools (Coming Soon!)
                        </span>
                      </li>
                    </ul>
                  </Section>
                </div>
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};